import * as React from "react"
import { useReadLegalEntityMetadataQuery } from "@digits-graphql/frontend/graphql-bearer"
import useSession from "@digits-shared/hooks/useSession"
import dayjs from "@digits-shared/initializers/dayjs/dayjs"
import { useViewVersion } from "src/frontend/components/Shared/Contexts/useViewVersion"
import type FrontendSession from "src/frontend/session"

export function useFirstTransactionTimestamp(skip?: boolean) {
  const viewKey = useViewVersion()
  const { isSharingContextActive } = useSession<FrontendSession>()
  const { data, loading, error } = useReadLegalEntityMetadataQuery({
    variables: {
      viewKey,
    },
    skip:
      !viewKey || !viewKey.legalEntityId || !viewKey.viewVersion || isSharingContextActive || skip,
  })

  return React.useMemo(() => {
    const firstTransactionTimestamp = data?.readLegalEntityMetadata?.firstTransactionTimestamp || 0
    const date = dayjs.unix(firstTransactionTimestamp)
    const firstTransactionMonth = date.month()
    const firstTransactionYear = date.year()
    return {
      loading,
      error,
      firstTransactionTimestamp,
      firstTransactionMonth,
      firstTransactionYear,
    }
  }, [data?.readLegalEntityMetadata?.firstTransactionTimestamp, error, loading])
}
